import { createSlice } from '@reduxjs/toolkit';
import { IGantt } from '../components/apia/monitor/gantt/ganttJSON';
import { TApiaFilterOption } from '../types';

type TGanttSlice = {
  id: string;
  options: TApiaFilterOption[];
  currentValue: number | undefined;
  data?: IGantt[] | null;
  userInput?: boolean;
};

/**
 * This slice is intended to keep information about the GanttChart component.
 */
const ganttSlice = createSlice({
  name: 'ganttSlice',
  initialState: {} as TGanttSlice,
  reducers: {
    set(
      state,
      {
        payload: { id, options, data },
      }: {
        payload: {
          id: string;
          options: TApiaFilterOption[];
          newValue?: number;
          data?: IGantt[] | null;
        };
      },
    ) {
      const value = () => {
        let valueTotal;
        options.forEach((option) => {
          if (option.selected) {
            valueTotal = option.value;
          }
        });
        return valueTotal;
      };
      state.id = id;
      state.options = options;
      state.currentValue = value();
      state.data = data;
    },
    changeScale(
      state,
      {
        payload: { newValue, userInput },
      }: { payload: { newValue: number; userInput: boolean } },
    ) {
      state.options.map((current) => {
        return {
          ...current,
          selected: current.value === newValue,
        };
      });

      state.currentValue = newValue;
      if (userInput) {
        state.userInput = true;
      }
    },
  },
});

export const ganttActions = ganttSlice.actions;
export default ganttSlice.reducer;
